import localStore from "./localstorage.util";

export const getToken = () => localStore.get_data("token");

export const setToken = (token) => localStore.store_data("token", token);

export const logoutT = () => {
  localStore.remove_data("token");
  localStore.remove_data("UserInfo");
  window.location.href = '/login';
  return true;
};

export const isLoggedIn = () => {
  const token = getToken();
  return !!token;
};